import React from 'react';
import { LFC } from '../../Legacy';
import { BetterDropButton } from '../../ui/DropButton';
import { useResolve } from '../Container';
import { Page } from '../common/Page';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { BoardInfo } from './BoardInfo';
import { EditorSession } from './EditorSession';

export const TemplateHeaderBlock: LFC = () => {
    const { id: boardId } = useResolve(EditorSession).get(BoardInfo);
    return <Page.HeaderBlock>
        <Flexer flex="row" padding="0 .5 0 0">
            <a href={`/new/${boardId}`}>
                <BetterDropButton variant="primary" padding=".5">
                    <span style={{ fontWeight: 450 }}>Use This Template</span>
                </BetterDropButton>
            </a>
        </Flexer>
    </Page.HeaderBlock>;
};
